export const environment = {
    production: true,
    //    apiUrl: 'http://3.16.114.108:5001',
    //    apiUrl: 'http://18.220.90.119:5001',
    //    apiUrl: 'http://localhost:5001',
    //  apiUrl: 'https://qa.server.listfunding.com',
    apiUrl: '',
    contactUs: 'izik@listfunding.com',
    calculationMode: false,
    stripe: {
        publicKey: 'pk_test_51O2ZBrHbKErP6glsI1b6JoBXgwXFFzY75UjlLvXNpcFMj0T6v4Selwb8UjEG9hrLvRUuIpIhtXiJapgNjbmAQKdn00cBGRTYPp',
    },
    snfClient: '',
    firebaseConfig: {
        apiKey: "AIzaSyBZ_MJ0WtpvYaONEtRBJyG-GsQ__YkDYpU",
        authDomain: "snfs-e8d55.firebaseapp.com",
        projectId: "snfs-e8d55",
        storageBucket: "snfs-e8d55.firebasestorage.app",
        messagingSenderId: "948893991899",
        appId: "1:948893991899:web:dbc630b1e599e388d15dfe"
    },
    CLIENTS_NAMES: {
        'ATLAS': 'atlas',
        "CCARE": 'ccare',
        "EMPIRE": 'empire',
        "CCARECT": 'ccarect',
        "ECARE": 'ecare',
        "CORECARE": 'corecare',
        "JEWEL": 'jewel',
        "VIVO": 'vivo',
        "MONTCARE": 'montcare',
        "MOMENTOUS": 'momentous',
        "HERITAGE": 'heritage',
        "SUMMITCARE": 'summitcare',
        "AWARDCARE": 'awardcare',
        "ARCADIA": 'arcadia',
        "LAKELAND": 'lakeland',
        "PREMIER": 'premier'
    },
    // Our own staff's email domains. A check run from one of these accounts shows as run by
    // "System" (SNF-873 eligibility card), never by the staff member's email.
    SYSTEM_USER_DOMAINS: ['snfai.com', 'listfunding.com'],
    env: 'dev',
    isDemo: false,
    highRiskBedboard: false,
    pccPushScreenV2: false
};

// ─── Runtime per-site config (Phase 2 deploy architecture) ───────────────────
// window.__APP_CONFIG__ is set by /config.js, loaded as a blocking script in
// index.html before any app bundle. At deploy time scripts/gen-config.js
// overwrites config.js per site from config/clients.json; the in-repo default
// config.js sets nothing, so local ng serve and legacy per-client builds keep
// exact legacy behavior (this whole block is then a no-op).
//
// Validity is strict and all-or-nothing: a config missing a non-empty string
// apiUrl OR snfClient is treated as ABSENT — it is never partially applied.
// This file must NEVER throw on a missing config: legacy per-client builds
// (environment.<client>.ts) also import it and legitimately run with no
// runtime config. The fail-closed refusal to boot for the universal bundle
// lives in environment.ts, which legacy builds replace away via angular.json
// fileReplacements.
const raw = (typeof window !== "undefined" && (window as any).__APP_CONFIG__) || null;

export const RUNTIME_CONFIG = raw;

// Fail-closed contract: BOTH apiUrl and snfClient must be non-empty strings;
// anything else is invalid and nothing from the config is applied.
export const RUNTIME_CONFIG_VALID = !!(RUNTIME_CONFIG &&
    typeof RUNTIME_CONFIG.apiUrl === "string" && RUNTIME_CONFIG.apiUrl.length > 0 &&
    typeof RUNTIME_CONFIG.snfClient === "string" && RUNTIME_CONFIG.snfClient.length > 0);

if (RUNTIME_CONFIG_VALID) {
    environment.apiUrl = RUNTIME_CONFIG.apiUrl;
    environment.snfClient = RUNTIME_CONFIG.snfClient;
    // flags = environment-field overrides, shallow-merged. Only keys that
    // already exist on the environment object are applied; unknown keys are
    // ignored defensively.
    if (RUNTIME_CONFIG.flags && typeof RUNTIME_CONFIG.flags === "object") {
        for (const key in RUNTIME_CONFIG.flags) {
            if (Object.prototype.hasOwnProperty.call(RUNTIME_CONFIG.flags, key) &&
                Object.prototype.hasOwnProperty.call(environment, key)) {
                (environment as any)[key] = RUNTIME_CONFIG.flags[key];
            }
        }
    }
}

// Local dev ALWAYS talks to the local server — wins regardless of runtime config.
if (typeof window !== "undefined" &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
    environment.apiUrl = "http://localhost:5001";
}
